import { createSlice } from '@reduxjs/toolkit';
import initialState from './Authorization.state';
import reducers from './Authorization.reducers';

export default createSlice({
	name: 'Authorization',
	initialState,
	reducers,
});
